import { render, staticRenderFns } from "./awardBenefits.vue?vue&type=template&id=ae7efdfe&scoped=true&"
import script from "./awardBenefits.vue?vue&type=script&lang=js&"
export * from "./awardBenefits.vue?vue&type=script&lang=js&"
import style0 from "./awardBenefits.vue?vue&type=style&index=0&id=ae7efdfe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae7efdfe",
  null
  
)

export default component.exports